<script lang="ts">
    import { onDestroy } from 'svelte'

    import { gettext as _ } from 'hydria/services/gettext'
    import { sgoto } from 'hydria/svelte_helpers'

    let timer: ReturnType<typeof setTimeout> | undefined = setTimeout(() => {
        timer = undefined
        sgoto('/')
    }, 7000)

    onDestroy(() => {
        if (timer) {
            clearTimeout(timer)
            timer = undefined
        }
    })
</script>

<div class="404"><p>{$_('Page not found…')}</p></div>
